import { Platform, TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import Button from '@src/components/Button';
import DropDown from '@src/components/DropDown';
import { Subtitle1 } from '@src/components/Typography';

const AVATAR_SIZE = 100;

export const Row = styled.View`
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.View`
  margin: 10px 0px;
`;

export const SubmitButton = styled(Button)`
  color: ${({ theme }) => theme.colors.text};
`;

export const AvatarContainer = styled.View`
  margin: 0px auto;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${AVATAR_SIZE}px;
  border-radius: ${AVATAR_SIZE / 2}px;
`;

export const AvatarImage = styled(Avatar).attrs({
  size: AVATAR_SIZE,
})`
  align-self: center;
`;

export const AvatarEditText = styled(Subtitle1)`
  width: 100%;
  margin: 0 auto;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 1px 2px;
  border-radius: 4px;
  overflow: hidden;
  ${Platform.OS === 'web' && 'backdrop-filter: blur(5px);'}
`;

export const Touchable = styled(TouchableOpacity)`
  justify-content: center;
  align-items: center;
  align-self: center;
`;

export const GenderPicker = styled(DropDown).attrs(({ theme }) => ({
  multiSelect: false,
  mode: 'outlined',
  inputProps: {
    dense: false,
    style: {
      fontSize: theme.typography.body[1].fontSize,
      minWidth: 120,
    },
  },
  iconSize: theme.typography.body[1].fontSize,
}))``;
